import React from 'react';
import T from 'prop-types';

const SectionSummary = ({ title, description, children }) => (
  <header className="section-summary">
    <div className="section-summary__left">
      <h3 className="section-summary__title h3">{title}</h3>
      <p className="section-summary__description">{description}</p>
    </div>
    <div className="section-summary__content">{children}</div>
  </header>
);

SectionSummary.propTypes = {
  title: T.string.isRequired,
  description: T.string,
  children: T.node,
};

export default SectionSummary;
